// extracted by mini-css-extract-plugin
export var heroImage = "index-module--heroImage--2Upsf";
export var titleWrapper = "index-module--titleWrapper--3B94N";
export var title = "index-module--title--33R7c";
export var overlay = "index-module--overlay--bgKav";